import React from 'react';
import Lottie from 'react-lottie';

import emptyData from '../../../assets/animations/empty.json';
import classNames from './dashboard.module.scss';

interface DBEmptyDataProps {
	isVisible: boolean;
	message: string;
}

const DBEmptyData: React.FC<DBEmptyDataProps> = ({ isVisible, message }) => {
	if (!isVisible) return null;

	return (
		<div className={classNames.dbEmptyData}>
			<Lottie options={defaultOptions} />

			<div className={classNames.dbEmptyDataMessage}>{message}</div>
		</div>
	);
};

const defaultOptions = {
	loop: true,
	autoplay: true,
	animationData: emptyData,
	rendererSettings: {
		preserveAspectRatio: 'xMidYMid slice',
	},
};

export default DBEmptyData;
